import styled from '@mui/material/styles/styled';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

import { colors } from 'src/utils/customColors';

export const Styled = {
  StyledToggleGroup: styled(ToggleButtonGroup)(({ theme }) => ({
    border: `thin solid ${theme.palette.divider}`,
    borderRadius: theme.spacing(3.125),
  })),
  StyledToggleButton: styled(ToggleButton)<{ fontSize?: string }>(
    ({ theme, fontSize }) => ({
      border: 'none',
      fontWeight: '600',
      padding: theme.spacing(0.55, 2),
      color: theme.palette.primary.main,
      borderRadius: theme.spacing(3.125),
      fontSize: fontSize ?? theme.spacing(2),
      '&:hover': { background: 'transparent' },
      '&.Mui-selected': {
        color: colors.darkerTurquoise,
        background: colors.lightestBlue,
        borderRadius: theme.spacing(3.125),
        border: `thin solid ${colors.lightBlue}`,
        '&:hover': {
          color: colors.darkerTurquoise,
          background: colors.lightestBlue,
          borderRadius: theme.spacing(3.125),
          border: `thin solid ${colors.lightBlue}`,
        },
      },
    }),
  ),
};
